/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-25 19:22:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 19:28:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/Reviews/Title.tsx
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { getProductInfo } from '../slice';
import { EnumReviewType } from '../../common';

const Title = (props) => {
  const { label, value } = props;
  const data: any = useSelector(getProductInfo()) || {};
  const {
    pendingAmount = 0,
    archiveAmount = 0,
    spamAmount = 0,
    publishedAmount = 0,
    totalAmount = 0,
  } = data;
  const obj = {
    [EnumReviewType.All]: totalAmount,
    [EnumReviewType.Archive]: archiveAmount,
    [EnumReviewType.Pending]: pendingAmount,
    [EnumReviewType.Published]: publishedAmount,
    [EnumReviewType.Spam]: spamAmount,
  };
  return (
    <span>
      {label}&nbsp;
      {`(${obj[value] || 0})`}
    </span>
  );
};
export default Title;
